import Cadence from "@/assets/svg/task/clients/cadence-talent.svg";
import ClicksTalent from "@/assets/svg/task/clients/clicks-talent.svg";
import Creatorshield from "@/assets/svg/task/clients/creator-shield.svg";
import DigitalFox from "@/assets/svg/task/clients/digital-fox.svg";
import Facebook from "@/assets/svg/task/clients/facebook.svg";
import Microsoft from "@/assets/svg/task/clients/microsoft.svg";
import PMG from "@/assets/svg/task/clients/pmg.svg";
import SocialXTalent from "@/assets/svg/task/clients/social-x-talent.svg";
import Talentir from "@/assets/svg/task/clients/talentir.svg";
import Tiddle from "@/assets/svg/task/clients/tiddle.svg";
import UnderCurrent from "@/assets/svg/task/clients/under-current.svg";
import Viralish from "@/assets/svg/task/clients/viralish.svg";
import Wooglobe from "@/assets/svg/task/clients/wooglobe.svg";
import Youtube from "@/assets/svg/task/clients/youtube.svg";

export default function OurClients() {
  const clients = [
    DigitalFox,
    Facebook,
    Microsoft,
    Youtube,
    Viralish,
    Talentir,
    Wooglobe,
    Creatorshield,
    SocialXTalent,
    UnderCurrent,
    Cadence,
    ClicksTalent,
    PMG,
    Tiddle,
  ];
  const client1 = [
    DigitalFox,
    Facebook,
    Microsoft,
    Youtube,
    Viralish,
    Talentir,
    Wooglobe,
  ];
  const client2 = [
    Creatorshield,
    SocialXTalent,
    UnderCurrent,
    Cadence,
    ClicksTalent,
    PMG,
    Tiddle,
  ];

  return (
    <div className="lg:py-10 mx-auto space-y-12 lg:space-y-20 w-[90%] 4xl:max-w-[100rem]">
      <div className="space-y-4 text-center">
        <h1 className="text-4xl md:text-5xl text-primaryLight">
          Our Clients & Partners
        </h1>
        <p className="text-[#EDE9FE] max-w-2xl mx-auto text-sm md:text-lg px-4">
          Enfinity partners with global leaders like Google, Microsoft, and
          YouTube, as well as fast-growing creator networks and talent agencies.
        </p>
      </div>
      <div className="hidden lg:grid grid-cols-7 gap-6">
        {clients.map((client, index) => (
          <div key={index} className="w-fit">
            <img src={client} className="" alt="Icon" />
          </div>
        ))}
      </div>

      {/* Infinite scroll row */}
      <div className="space-y-4 lg:hidden">
        <div className="scroll-inner w-full pt-4">
          <div className="flex">
            {[1, 2, 3].map((dup) => (
              <section
                key={dup}
                className="scroll-section-left"
                style={{ "--speed": "40000ms" }}
              >
                {client1.map((client, index) => (
                  <div
                    key={`${index}-${dup}`}
                    className="flex justify-center items-center w-36 h-16 mx-4 hover:scale-110 transition-transform duration-300"
                  >
                    <img
                      src={client}
                      alt="Icon"
                      className="max-h-24 object-contain"
                    />
                  </div>
                ))}
              </section>
            ))}
          </div>
        </div>
        <div className="scroll-inner w-full pt-4">
          <div className="flex">
            {[1, 2, 3].map((dup) => (
              <section
                key={dup}
                className="scroll-section-right"
                style={{ "--speed": "40000ms" }}
              >
                {client2.map((client, index) => (
                  <div
                    key={`${index}-${dup}`}
                    className="flex justify-center items-center w-36 h-16 mx-4 hover:scale-110 transition-transform duration-300"
                  >
                    <img
                      src={client}
                      alt="Icon"
                      className="max-h-24 object-contain"
                    />
                  </div>
                ))}
              </section>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
